import { useMemo } from 'react';

import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import {
  EMPLOYMENT_TYPE_OPTIONS,
  EMPLOYMENT_TYPE_VALIDATION,
  MONTHLY_INCOME_VALIDATION,
  SELF_EMPLOYED_PROPS,
} from './constants';

import { ERROR_PROPS } from '../../PrimaryEmployment/constants';
import useEmploymentStatusFields from '../../PrimaryEmployment/useEmploymentStatusFields';
import EmploymentAddressFields from '../EmploymentAddressFields';
import { MONTHS_OPTIONS } from '../EmploymentMonths/constants';

export interface SelfEmployedSecondaryProps {
  index: number;
  arrayName: string;
}

const SelfEmployedSecondary: React.FunctionComponent<SelfEmployedSecondaryProps> =
  function ({ index, arrayName }) {
    const { error, validation, yearsName, monthsName, yearsOptions } =
      useEmploymentStatusFields({
        type: 'secondary',
        employmentType: 'self_employed',
        index,
        arrayName,
      });
    const baseName = useMemo(
      () => `${arrayName}.${index}.self_employed_details`,
      [arrayName, index],
    );
    const employmentTypeName = useMemo(
      () => `${baseName}.self_employed_type`,
      [baseName],
    );
    const monthlyTakeHomeName = useMemo(
      () => `${baseName}.monthly_income_after_tax`,
      [baseName],
    );
    return (
      <div className="grid grid-cols-2 gap-x-3 md:gap-x-4">
        <Field.Validator validation={EMPLOYMENT_TYPE_VALIDATION}>
          <Field.Select
            {...SELF_EMPLOYED_PROPS.selfEmployedType}
            options={EMPLOYMENT_TYPE_OPTIONS}
            name={employmentTypeName}
          />
        </Field.Validator>
        <Field.Validator validation={MONTHLY_INCOME_VALIDATION}>
          <Field.NumberInput
            {...SELF_EMPLOYED_PROPS.monthlyIncome}
            name={monthlyTakeHomeName}
          />
        </Field.Validator>
        <Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsBusinessNameArrayInput
          {...SELF_EMPLOYED_PROPS.businessName}
          className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
          index={index}
          name="self_employed_details.business_name"
        />
        <Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsTypeOfBusinessArrayInput
          {...SELF_EMPLOYED_PROPS.typeOfBusiness}
          className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
          name="self_employed_details.type_of_business"
        />
        <div className="col-span-2">
          <EmploymentAddressFields
            employmentStatus="self_employed"
            employmentClass="secondary"
            index={index}
            arrayName={arrayName}
          />
        </div>
        <span className="col-span-2 text-12-18-em text-neutral-700 w-full mb-2">
          When did you start your self-employment/business?
        </span>
        <Field.Select
          options={MONTHS_OPTIONS}
          name={monthsName}
          placeholder="Month"
        />
        <Field.Select
          options={yearsOptions}
          name={yearsName}
          placeholder="Year"
        />
        {error && <Text text={error} className={ERROR_PROPS.className} />}
        <div className="hidden">
          <Widget.CreditAdditionalEmploymentDetailsSelfEmployedDetailsMonthsSelfEmployedArrayInput
            validation={validation}
            name="self_employed_details.months_self_employed"
          />
        </div>
      </div>
    );
  };

export default SelfEmployedSecondary;
